var collectionBanner = document.querySelector('.shopify-section--collection-banner');
     var collectionSlideshow = document.querySelector('.shopify-section--slideshow');
     var collectionImageWithTextOverlay = document.querySelector('.shopify-section--image-with-text-overlay');
      if(collectionBanner || collectionSlideshow || collectionImageWithTextOverlay) {        
        document.querySelector('body').classList.add('caremare-logo');

        window.addEventListener("scroll", () => {
        if(window.scrollY > 0) {
            document.querySelector('body').classList.remove('caremare-logo');
        } else {
            document.querySelector('body').classList.add('caremare-logo');
        }
        });
      }

